export default "__VITE_ASSET__7dc8ec1b__"